"use strict";
const _ = require("lodash");

class TimePickerRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("time-picker-gl"); //TODO Setup the root Element
        if (this._model.disabled) {
            this._rootElem.classList.add("disabled");
        }
        if (this._model.darkTheme) {
            this._rootElem.classList.add("dark");
        }
        if (this._model.theme) {
            this._rootElem.classList.add(this._model.theme);
        }
        if (!this._model.visible) {
            this._rootElem.classList.add("hidden");
        }
        this._rootElem.addEventListener("focus", (this._onFocused = this._onFocused.bind(this)));
        this._rootElem.addEventListener("blur", (this._onBlurred = this._onBlurred.bind(this)));
        this._rootElem.component = this._model;
        this._onHourClickBound = this._onHourClick.bind(this); // necessary for enable/disable to work
        this._onMinuteClickBound = this._onMinuteClick.bind(this); // necessary for enable/disable to work
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._model.on("Value", (this._onValue = this._onValue.bind(this)));
        this._model.on("Disabled", (this._onDisabled = this._onDisabled.bind(this)));
        this._model.on("Visible", (this._onVisible = this._onVisible.bind(this)));
        this._model.on("ShowHours", (this._onShowHours = this._onShowHours.bind(this)));
        this._model.on("ShowMinutes", (this._onShowMinutes = this._onShowMinutes.bind(this)));
        this._model.on("DarkTheme", (this._onDarkTheme = this._onDarkTheme.bind(this)));
        this._model.on("Theme", (this._onTheme = this._onTheme.bind(this)));
        this._model.on("Focus", (this._onFocus = this._onFocus.bind(this)));
        this._model.on("Blur", (this._onBlur = this._onBlur.bind(this)));
        this._model.on("SetAttribute", (this._onSetAttribute = this._onSetAttribute.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Value", this._onValue);
        this._model.removeListener("Disabled", this._onDisabled);
        this._model.removeListener("Visible", this._onVisible);
        this._model.removeListener("ShowHours", this._onShowHours);
        this._model.removeListener("ShowMinutes", this._onShowMinutes);
        this._model.removeListener("DarkTheme", this._onDarkTheme);
        this._model.removeListener("Theme", this._onTheme);
        this._model.removeListener("Focus", this._onFocus);
        this._model.removeListener("Blur", this._onBlur);
        this._model.removeListener("SetAttribute", this._onSetAttribute);
    }

    _onFocus() {
        this._rootElem.focus();
    }

    _onBlur() {
        this._rootElem.blur();
    }

    /**
     * Fired when setAttribute has been called in the model
     * @param attrName {String} - The name of the HTML attribute to be set on the native control
     * @param attrValue {String|Undefined} - The value of the HTML attribute to be set on the native control
     * @private
     */
    _onSetAttribute(attrName, attrValue) {
        this._setAttribute(attrName, attrValue);
    }

    _onFocused(evt) {
        this._model._triggerUserFocus(evt);
    }

    _onBlurred(evt) {
        this._model._triggerUserBlur(evt);
    }

    _onVisible(bool) {
        if (bool) {
            this._rootElem.classList.remove("hidden");
        } else {
            this._rootElem.classList.add("hidden");
        }
    }

    _onDarkTheme(bool) {
        if (bool) {
            this._rootElem.classList.add("dark");
        } else {
            this._rootElem.classList.remove("dark");
        }
    }

    _onTheme(newVal, oldVal) {
        if (newVal) {
            this._rootElem.classList.add(newVal);
        }
        if (oldVal) {
            this._rootElem.classList.remove(oldVal);
        }
    }

    _onValue() {
        if (this._hoursContainerElem) {
            this._renderHours();
        } else if (this._minutesContainerElem) {
            this._renderMinutes();
        }
    }

    _onDisabled(bool) {
        if (bool) {
            this._onDisable();
        } else {
            this._onEnable();
        }
    }

    _onEnable() {
        this._rootElem.classList.remove("disabled");
        if (this._hoursContainerElem) {
            this._hoursContainerElem.classList.remove("disabled");
            _.each(this._hourElements, (hourElem) => {
                hourElem.addEventListener("click", this._onHourClickBound);
                hourElem.classList.remove("disabled");
            });
        } else if (this._minutesContainerElem) {
            this._minutesContainerElem.classList.remove("disabled");
            _.each(this._minuteElements, (minuteElem) => {
                minuteElem.addEventListener("click", this._onMinuteClickBound);
                minuteElem.classList.remove("disabled");
            });
        }
    }

    _onDisable() {
        this._rootElem.classList.add("disabled");
        if (this._hoursContainerElem) {
            this._hoursContainerElem.classList.add("disabled");
            _.each(this._hourElements, (hourElem) => {
                hourElem.removeEventListener("click", this._onHourClickBound);
                hourElem.classList.add("disabled");
            });
        } else if (this._minutesContainerElem) {
            this._minutesContainerElem.classList.add("disabled");
            _.each(this._minuteElements, (minuteElem) => {
                minuteElem.removeEventListener("click", this._onMinuteClickBound);
                minuteElem.classList.add("disabled");
            });
        }
    }

    _onShowHours() {
        if (this._minutesContainerElem) {
            this._removeMinutes();
        }
        this._renderHours();
    }

    _onShowMinutes() {
        if (this._hoursContainerElem) {
            this._removeHours();
        }
        this._renderMinutes();
    }

    _renderHours() {
        if (this._minutesContainerElem) {
            this._removeMinutes();
        }
        if (!this._hoursContainerElem) {
            this._hoursContainerElem = document.createElement("time-picker-hours-container-gl");
            this._hourElements = [];
            let hourElem;
            for (let i = 1; i < 13; i++) {
                hourElem = document.createElement("hour-gl");
                hourElem.innerHTML = i;
                hourElem.addEventListener("click", this._onHourClickBound);
                this._hoursContainerElem.appendChild(hourElem);
                this._hourElements.push(hourElem);
            }
            this._rootElem.appendChild(this._hoursContainerElem);
        }
        let hr = this._model.value.format("h");
        _.each(this._hourElements, (hourElem) => {
            if (hr === hourElem.innerHTML) {
                hourElem.classList.add("selected");
            } else {
                hourElem.classList.remove("selected");
            }
        });
    }

    _removeHours() {
        if (this._hoursContainerElem) {
            _.each(this._hourElements, (elem) => {
                elem.remove();
            });
            this._hourElements = undefined;
            this._hoursContainerElem.remove();
            this._hoursContainerElem = undefined;
        }
    }

    _onHourClick(evt) {
        let hr = Number.parseInt(evt.target.innerHTML);
        let isPM = this._model.value.get("hour") > 11 ? true : false;
        if (isPM) {
            hr = hr + 12;
        }
        this._model.setValue({hour: hr}, true, evt);
    }

    _renderMinutes() {
        if (this._hoursContainerElem) {
            this._removeHours();
        }
        if (!this._minutesContainerElem) {
            this._minutesContainerElem = document.createElement("time-picker-minutes-container-gl");
            this._minuteElements = [];
            let minuteElem;
            for (let i = 0; i < 60; i++) {
                minuteElem = document.createElement("minute-gl");
                let minStr = _.padStart(i, 2, 0);
                if (i % 5 === 0) {
                    minuteElem.classList.add("major-minute");
                    minuteElem.innerHTML = minStr;
                } else {
                    minuteElem.classList.add("minor-minute");
                    minuteElem.innerHTML = " ";
                }
                minuteElem.setAttribute("minute", minStr);
                minuteElem.addEventListener(
                    "click",
                    (this._onMinuteClick = this._onMinuteClick.bind(this))
                );
                this._minutesContainerElem.appendChild(minuteElem);
                this._minuteElements.push(minuteElem);
            }
            this._rootElem.appendChild(this._minutesContainerElem);
        }
        let min = this._model.value.format("mm");
        _.each(this._minuteElements, (minuteElem) => {
            if (min === minuteElem.getAttribute("minute")) {
                minuteElem.classList.add("selected");
            } else {
                minuteElem.classList.remove("selected");
            }
        });
    }

    _removeMinutes() {
        if (this._minutesContainerElem) {
            _.each(this._minuteElements, (elem) => {
                elem.remove();
            });
            this._minuteElements = undefined;
            this._minutesContainerElem.remove();
            this._minutesContainerElem = undefined;
        }
    }

    _onMinuteClick(evt) {
        let min = Number(evt.target.getAttribute("minute"));
        this._model.setValue({minute: min}, true, evt);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._removeHours();
            this._removeMinutes();
            this._onHourClickBound = undefined;
            this._onMinuteClickBound = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._model = undefined;
            resolve();
        });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (this._model.view === "minutes") {
                this._onShowMinutes();
            } else {
                this._onShowHours();
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        this.render();
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /**
     * Set an attribute on the native control
     * @param attrName {String} - The name of the HTML attribute to be set on the native control
     * @param attrValue {String|Undefined} - The value of the HTML attribute to be set on the native control
     * @private
     */
    _setAttribute(attrName, attrValue) {
        if (!_.isUndefined(attrValue)) {
            this._rootElem.setAttribute(attrName, attrValue);
        } else {
            this._rootElem.removeAttribute(attrName);
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = TimePickerRenderer;
